import { useMassActivityExportForm } from '@/modules/activities/hooks'
import { ExportFormat, ExportOption } from '@/modules/exports'
import {
  ExportCard,
  ExportPeriodField,
} from '@/modules/exports/components/export-form'
import { EXPORT_UNKNOWN_LOCATIONS } from '@/modules/exports/mutations'
import { useOnErrorAuto, useUser } from '@/utils/hooks'
import { useMutation } from '@apollo/client'
import { useToast } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useEffect } from 'react'

export const ExportUnknownDriverLocations: React.FC = () => {
  const me = useUser()
  const translations = useTranslate({
    unknownDriverAndDrivingWithoutCard:
      'activities.unknown-driver-and-driving-without-card',
    error: 'error.generic-server-error',
    downloadSuccess: 'exports.success-user-exports',
  })

  const { loading, form, updateForm, getExportDateInterval } =
    useMassActivityExportForm()

  const onErrorAuto = useOnErrorAuto()
  const addToast = useToast()

  const [doExport] = useMutation(EXPORT_UNKNOWN_LOCATIONS, {
    onCompleted(data) {
      if (data?.exportUnknownLocations.ok) {
        addToast('success', translations.downloadSuccess)
      } else addToast('error', translations.error)
    },
    onError: onErrorAuto(translations.error),
  })

  function handleSubmit() {
    const [dateStart, dateEnd] = getExportDateInterval()
    void doExport({
      variables: {
        user: me.id,
        dateStart,
        dateEnd,
      },
    })
  }

  useEffect(() => {
    if (
      form.exportOption === ExportOption.DOWNLOAD &&
      form.exportFormat !== ExportFormat.PDF
    ) {
      updateForm({ exportFormat: ExportFormat.PDF })
    }
  }, [form.exportOption, form.exportFormat, updateForm, form.exportType])

  return (
    <ExportCard
      title={translations.unknownDriverAndDrivingWithoutCard}
      loading={loading}
      onSubmit={handleSubmit}
    >
      <ExportPeriodField
        value={form}
        wide
        onChange={value => updateForm(value)}
      />
    </ExportCard>
  )
}
